import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: () => import('./views/Inicio.vue'),
      meta: { Auth: false }
    },
    {
      path: '/p/:idProducto',
      name: 'Producto',
      props: true,
      component: () => import('./views/Producto.vue'),
      meta: { Auth: false }
    },
    {
      path: '/confirmarnewsletter/:uid',
      alias: '/confirmnewsletter/:uid',
      name: 'ConfirmarNewsletter',
      props: true,
      component: () => import('./components/ConfirmarNewsletter.vue'),
      meta: { Auth: false }
    },
    {
      path: '/acceso',
      alias: '/login',
      name: 'Acceso',
      component: () => import('./views/Acceso.vue'),
      meta: { Auth: false }
    },
    {
      path: '/administracion',
      alias: '/administration',
      name: 'Administracion',
      component: () => import('./views/Administracion.vue'),
      meta: { Auth: true, rol: ['administrador'] },
      children: [
        {
          name: 'AdministracionGeneral',
          path: '/administracion/general',
          alias: '/administration/general',
          component: () => import('./views/Administracion/General.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionAplicaciones',
          path: '/administracion/aplicaciones',
          alias: '/administration/applications',
          component: () => import('./views/Administracion/Aplicaciones.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionMagazine',
          path: '/administracion/magazine',
          component: () => import('./views/Administracion/Magazine.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionPaginas',
          path: '/administracion/paginas',
          alias: '/administration/pages',
          component: () => import('./views/Administracion/Paginas.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionProductos',
          path: '/administracion/productos',
          alias: '/administration/products',
          component: () => import('./views/Administracion/Productos.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionUsuarios',
          path: '/administracion/usuarios',
          alias: '/administration/users',
          component: () => import('./views/Administracion/Usuarios.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionExperiencias',
          path: '/administracion/experiencias',
          alias: '/administration/experiences',
          component: () => import('./views/Administracion/Experiencias.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionManual',
          path: '/administracion/capacitacion',
          alias: '/administration/training',
          component: () => import('./views/Administracion/Manual.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionContratos',
          path: '/administracion/contratos',
          alias: '/administration/contracts',
          component: () => import('./views/Administracion/Contratos.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionCertificados',
          path: '/administracion/certificados',
          alias: '/administration/certificates',
          component: () => import('./views/Administracion/Certificados.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionPedidos',
          path: '/administracion/pedidos',
          alias: '/administration/orders',
          component: () => import('./views/Administracion/Pedidos.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionPagos',
          path: '/administracion/pagos',
          alias: '/administration/payments',
          component: () => import('./views/Administracion/Pagos.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionNewsletter',
          path: '/administracion/newsletter',
          alias: '/administration/newsletter',
          component: () => import('./views/Administracion/Newsletter.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        },
        {
          name: 'AdministracionCupones',
          path: '/administracion/cupones',
          alias: '/administration/coupons',
          component: () => import('./views/Administracion/Cupones.vue'),
          meta: { Auth: true, rol: ['administrador'] }
        }
      ]
    },
    {
      path: '/magazine',
      name: 'Magazine',
      component: () => import('./views/Magazine.vue'),
      meta: { Auth: false }
    },
    {
      path: '/articulo/:enlace',
      alias: '/article/:enlace',
      props: true,
      name: 'Articulo',
      component: () => import('./views/Articulo.vue'),
      meta: { Auth: false }
    },
    {
      path: '/artistas',
      alias: '/artists',
      name: 'Artistas',
      component: () => import('./views/Artistas.vue'),
      meta: { Auth: false }
    },
    {
      path: '/disenadores',
      alias: '/designers',
      name: 'Disenadores',
      component: () => import('./views/Disenadores.vue'),
      meta: { Auth: false }
    },
    {
      path: '/eventos',
      alias: '/events',
      name: 'Eventos',
      component: () => import('./views/Experiencias/Eventos.vue'),
      meta: { Auth: false }
    },
    {
      path: '/tours',
      name: 'Tours',
      component: () => import('./views/Experiencias/Tours.vue'),
      meta: { Auth: false }
    },
    {
      path: '/club',
      name: 'Club',
      component: () => import('./views/Experiencias/Club.vue'),
      meta: { Auth: false }
    },
    {
      path: '/backoffice',
      name: 'Oficina',
      component: () => import('./views/Oficina.vue'),
      meta: { Auth: true, rol: ['artista', 'administrador'] },
      children: [
        {
          name: 'ProductosOficina',
          path: '/backoffice/productos',
          alias: '/backoffice/products',
          component: () => import('./views/Oficina/Productos.vue'),
          meta: { Auth: true, rol: ['artista'] }
        },
        {
          name: 'CapacitacionOficina',
          path: '/backoffice/capacitacion',
          alias: '/backoffice/training',
          component: () => import('./views/Oficina/Capacitacion.vue'),
          meta: { Auth: true, rol: ['artista', 'administrador'] }
        },
        {
          name: 'VentasOficina',
          path: '/backoffice/ventas',
          alias: '/backoffice/sells',
          component: () => import('./views/Oficina/Ventas.vue'),
          meta: { Auth: true, rol: ['artista'] }
        },
        {
          name: 'SoporteOficina',
          path: '/backoffice/soporte',
          alias: '/backoffice/support',
          component: () => import('./views/Oficina/Soporte.vue'),
          meta: { Auth: true, rol: ['artista'] }
        }
      ]
    },
    {
      path: '/perfil',
      alias: '/profile',
      name: 'Perfil',
      component: () => import('./views/Perfil.vue'),
      meta: { Auth: true, rol: ['administrador', 'artista', 'cliente', 'moderador'] },
      children: [
        {
          name: 'GeneralPerfil',
          path: '/perfil/general',
          alias: '/profile/general',
          component: () => import('./views/Perfil/General.vue'),
          meta: { Auth: true, rol: ['administrador', 'artista', 'cliente', 'moderador'] }
        },
        {
          name: 'FavoritosPerfil',
          path: '/perfil/favoritos',
          alias: '/profile/favorites',
          component: () => import('./views/Perfil/Favoritos.vue'),
          meta: { Auth: true, rol: ['administrador', 'artista', 'cliente', 'moderador'] }
        },
        {
          name: 'PedidosPerfil',
          path: '/perfil/pedidos',
          alias: '/profile/orders',
          component: () => import('./views/Perfil/Pedidos.vue'),
          meta: { Auth: true, rol: ['administrador', 'artista', 'cliente', 'moderador'] }
        }
      ]
    },
    {
      path: '/u/:nombreDeUsuario',
      name: 'Usuario',
      props: true,
      component: () => import('./views/Usuario.vue'),
      meta: { Auth: false }
    },
    {
      path: '/porqueregistrarse',
      alias: '/whyregister',
      name: 'PorQueRegistrarse',
      component: () => import('./views/Footer/PorQueRegistrarse.vue'),
      meta: { Auth: false }
    },
    {
      path: '/carrito',
      alias: '/shoppingcart',
      name: 'Carrito',
      component: () => import('./components/Carrito.vue'),
      meta: { Auth: false }
    },
    {
      path: '/empresas',
      alias: '/business',
      name: 'Empresas',
      component: () => import('./views/Empresas.vue'),
      meta: { Auth: false }
    },
    {
      path: '/faq',
      name: 'Faq',
      component: () => import('./views/Footer/Faq.vue'),
      meta: { Auth: false }
    },
    {
      path: '/envios',
      alias: '/shipping',
      name: 'EnviosYDevoluciones',
      component: () => import('./views/Footer/EnviosYDevoluciones.vue'),
      meta: { Auth: false }
    },
    {
      path: '/porquecomprar',
      alias: '/whybuy',
      name: 'PorQueComprar',
      component: () => import('./views/Footer/PorQueComprar.vue'),
      meta: { Auth: false }
    },
    {
      path: '/asesoria',
      alias: '/advisory',
      name: 'Asesoria',
      component: () => import('./views/Footer/Asesoria.vue'),
      meta: { Auth: false }
    },
    {
      path: '/trabajaconnosotros',
      alias: '/workwithus',
      name: 'TrabajaConNosotros',
      component: () => import('./views/Footer/TrabajaConNosotros.vue'),
      meta: { Auth: false }
    },
    {
      path: '/alianzas',
      alias: '/alliances',
      name: 'Alianzas',
      component: () => import('./views/Footer/Alianzas.vue'),
      meta: { Auth: false }
    },
    {
      path: '/contactanos',
      alias: '/contactus',
      name: 'Contactanos',
      component: () => import('./views/Footer/Contactanos.vue'),
      meta: { Auth: false }
    },
    {
      path: '/tarjetaregalo',
      alias: '/giftcard',
      name: 'Regalo',
      component: () => import('./views/Footer/Regalo.vue'),
      meta: { Auth: false }
    },
    {
      path: '/tyc',
      name: 'TyC',
      component: () => import('./views/Footer/TyC.vue'),
      meta: { Auth: false }
    },
    {
      path: '/privacidad',
      alias: '/privacy',
      name: 'PoliticaDePrivacidad',
      component: () => import('./views/Footer/PoliticaDePrivacidad.vue'),
      meta: { Auth: false }
    },
    {
      path: '/quienessomos',
      alias: '/aboutus',
      name: 'QuienesSomos',
      component: () => import('./views/Footer/QuienesSomos.vue'),
      meta: { Auth: false }
    },
    {
      path: '/confirmacion',
      alias: '/confirmation',
      name: 'Confirmacion',
      component: () => import('./views/Confirmacion.vue'),
      meta: { Auth: false }
    },
    {
      path: '/desuscribirse',
      alias: '/unsuscribe',
      name: 'Desuscribirse',
      component: () => import('./views/Desuscribirse.vue'),
      meta: { Auth: false }
    },
    // New
    {
      path: '/creativecommons',
      alias: '/creativecommons',
      name: 'CreativeCommons',
      component: () => import('./views/Footer/CreativeC.vue'),
      meta: { Auth: false }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (store.state.cargado) {
    continuar()
  } else {
    var esperando = setInterval(() => {
      if (store.state.cargado === true) {
        continuar()
      }
    }, 500)
  }
  function continuar () {
    clearTimeout(esperando)
    if (to.meta.Auth) {
      if (store.state.usuarioModulo.usuario.rol === 'invitado') {
        next({ path: '/acceso' })
      } else {
        var cont = to.meta.rol.length
        for (let i = 0; i < to.meta.rol.length; i++) {
          if (to.meta.rol[i] === store.state.usuarioModulo.usuario.rol) {
            next()
            break
          }
          cont = cont - 1
          if (cont === 0) {
            next({ path: '/acceso' })
          }
        }
      }
    } else {
      next()
    }
  }
})
router.afterEach((to, from) => {
  document.body.scrollTop = document.documentElement.scrollTop = 0
})
export default router
